import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Svg } from '../common/Svg.js';
import { SchoolSublist } from './SchoolSublist.js';
import debounce from 'lodash/debounce.js';


export const RequestList = function ({ selectedMarker, clearSelectedResults, isMobile, schoolDonationEnabled}) {
    const [displayScrolledClass, setDisplayScrolledClass] = useState(false);
    const [selectedSublist, setSelectedSublist] = useState(null);
    const [sublists, setSublists] = useState(null);

    const selectedSchoolNames = selectedMarker && selectedMarker.schoolNames;
    const numFundable = selectedMarker && selectedMarker.numEssentialsResults + selectedMarker.numProjectResults;
    const hasMultipleSchools = selectedMarker && selectedMarker.schoolNames.length > 1;
    const hasRequests = numFundable > 0;

    const updateSelectedSublist = function(index) {
        if (selectedSublist !== null) {
            setSelectedSublist(null);
        } else {
            setSelectedSublist(index);
        }
    }


    const makeSublists = function() {
        const newSublists = []
        if (!selectedSchoolNames) {
            return newSublists;
        }

        for(let index = 0; index < selectedSchoolNames.length; index++) {
            if (selectedSublist !== null && index !== selectedSublist) {
                continue;
            }
            const schoolName = selectedSchoolNames[index];
            const school = selectedMarker.schoolsAtGeopoint[schoolName];
            const hasSchoolSearchResultData = (school['schools'] && school['schools'].length > 0);
            // Create a placeholder in the event there is no schoolData.
            // This happens because we're making multiple search index results and merging them back into geo-spacial data points
            // The nearest x projects, y essentials, and z schools will not always be the same set of points.
            const schoolData = hasSchoolSearchResultData ? school['schools'][0] : {schoolName : schoolName};
            schoolData['totalCostToComplete'] = school.totalCostToComplete;
            const projects = school['projects'];
            const essentials = school['essentials']
            const hasProjects = projects.length > 0;
            const hasEssentials = essentials.length > 0;
            if (!schoolData.hasOwnProperty('equityFocus')) {
                if (hasProjects) {
                    schoolData.equityFocus = projects[0].equityFocus;
                } else if (hasEssentials) {
                    schoolData.equityFocus = essentials[0].equityFocus;
                } else {
                    schoolData.equityFocus = false;
                }
            }
            if (!schoolData.hasOwnProperty('freeReducedPriceLunch')) {
                if (hasProjects) {
                    schoolData.freeReducedPriceLunch = projects[0].freeReducedPriceLunch;
                } else if (hasEssentials) {
                    schoolData.freeReducedPriceLunch = essentials[0].freeReducedPriceLunch;
                } else {
                    schoolData.freeReducedPriceLunch = false;
                }
            }
            newSublists.push(
                <SchoolSublist
                    key={'school-'+ index}
                    index={index}
                    projects={projects}
                    schoolData={schoolData}
                    essentials={essentials}
                    isMobile={isMobile}
                    hasMultipleSchools={hasMultipleSchools}
                    schoolDonationEnabled={schoolDonationEnabled}
                    isCollapsed={selectedSublist === index ? false : hasMultipleSchools}
                    toggleIsSelected={updateSelectedSublist}
                />
            );
        }
        return newSublists;
    }

    useEffect(() => {
        setSelectedSublist(null);
    }, [selectedMarker]);

    useEffect(() => {
        setDisplayScrolledClass(false);
        setSublists(makeSublists());
    },[selectedMarker, selectedSublist]);

    useEffect(() => {
        return () => {
            debouncedScrollHandler.cancel();
        }
    }, []);

    const handleScroll = function () {
        if (document.querySelector('.projects-box').scrollTop > 50) {
            setDisplayScrolledClass(true);
        } else {
            setDisplayScrolledClass(false);
        }
    };

    const debouncedScrollHandler = debounce(handleScroll, 250);

    if (!selectedMarker) {
        return null;
    }


    return (
        <div className={`project-details  ${hasMultipleSchools ? 'multiple-schools' : ''} ${!hasRequests ? 'no-requests' : ''} ${numFundable > 1 ? 'multiple' : 'single'}`}>
            <span tabIndex='0' className='close js-click-on-enter' role='presentation' onClick={clearSelectedResults}>
                <Svg icon='delete' attributes={{ role: 'presentation' }}/>
            </span>
            <div className={`projects-box${displayScrolledClass ? ' scrolled' : ''}`} onScroll={debouncedScrollHandler}>
                {sublists}
            </div>
        </div>
    );
};

RequestList.propTypes = {
    selectedMarker: PropTypes.object.isRequired,
    clearSelectedResults: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    schoolDonationEnabled: PropTypes.bool,
};
